import React, { useContext } from 'react';
import { Drawer, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { MenuContext } from '../../context/Menu';
import Logo from './Logo';
import Menu from './Menu';

const MenuContainer = styled('div')(`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`);

const SidebarContainer = styled('div')(({ theme }) => ({
  // Glassmorphism effect
  background: alpha(theme.palette.background.paper, 0.9),
  backdropFilter: 'blur(20px)',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  boxShadow: `8px 0 32px 0 ${alpha(theme.palette.common.black, 0.1)}`,

  height: '100%',
  width: '100%',
  borderRadius: '16px',
  overflow: 'hidden',
}));

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    // Glassmorphism effect for mobile drawer
    background: alpha(theme.palette.background.paper, 0.95),
    backdropFilter: 'blur(20px)',
    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    boxShadow: `8px 0 32px 0 ${alpha(theme.palette.common.black, 0.2)}`,
  },
}));

function Sidebar() {
  const { menuWidth } = useContext(MenuContext);
  return (
    <SidebarContainer style={{ width: `${menuWidth}px` }}>
      <MenuContainer>
        <div className="w-full">
          <Logo />
          <Menu />
        </div>
      </MenuContainer>
    </SidebarContainer>
  );
}

function ResponsiveSidebar() {
  const theme = useTheme();
  const renderMobileMenu = useMediaQuery(theme.breakpoints.down('md'));
  const { menuWidth, showMobileMenu, setShowMobileMenu } = useContext(MenuContext);
  const onClose = function () {
    setShowMobileMenu?.(false);
  };
  return (
    <>
      {renderMobileMenu && (
        <StyledDrawer anchor={'left'} open={showMobileMenu} onClose={onClose}>
          <div style={{ width: `${menuWidth}px`, height: '100%' }}>
            <Sidebar />
          </div>
        </StyledDrawer>
      )}
      {!renderMobileMenu && <Sidebar />}
    </>
  );
}

export default ResponsiveSidebar;
